// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__24-by","loaderOuter":"PageOverlayLoader_loaderOuter__1Xg_Q"};